import React, { Component } from "react";
import sunlifeLogo from "../assets/images/sunlife-takaful-logo.svg";
import bookdocLogo from "../assets/images/bookdocLogo.svg";
import { PROGRAM_CLOSE_DATE } from "constants/schedule";

const ALL_SECTION_IDS = [
  "home",
  "registration-form",
  "bonus-rewards",
  "programme-info",
  "diabetes-facts",
];

export class Header extends Component {
  constructor() {
    super();
    this.state = {
      hideDiv: false,
      activeItem: "home",
      menuOpen: false,
    };
  }

  componentDidMount() {
    this.scheduleHide();
    this.initScrollSpy();
  }

  componentWillUnmount() {
    if (this.timer) clearTimeout(this.timer);
    if (this.handleScroll)
      window.removeEventListener("scroll", this.handleScroll);
  }

  scheduleHide = () => {
    const now = new Date();
    const timeUntilHide = PROGRAM_CLOSE_DATE - now;
    const MAX_TIMEOUT = 2147483647;

    if (timeUntilHide <= 0) {
      this.setState({ hideDiv: true });
    } else if (timeUntilHide <= MAX_TIMEOUT) {
      this.timer = setTimeout(() => {
        this.setState({ hideDiv: true });
      }, timeUntilHide);
    }
  };

  initScrollSpy = () => {
    this.handleScroll = () => {
      const scrollY = window.scrollY + 100;
      const sectionIds = this.state.hideDiv
        ? ALL_SECTION_IDS.filter((id) => id !== "registration-form")
        : ALL_SECTION_IDS;
      let current = sectionIds[0];

      sectionIds.forEach((id) => {
        const el = document.getElementById(id);
        if (el && el.offsetTop <= scrollY) {
          current = id;
        }
      });

      if (this.state.activeItem !== current) {
        this.setState({ activeItem: current });
      }
    };

    window.addEventListener("scroll", this.handleScroll, { passive: true });
  };

  render() {
    const { hideDiv, activeItem, menuOpen } = this.state;
    const currentPath = window.location.pathname;

    const navLinks = [
      { id: "home", label: "Home", href: "#home" },
      ...(!hideDiv
        ? [
            {
              id: "registration-form",
              label: "Registration",
              href: "#registration-form",
            },
          ]
        : []),
      { id: "bonus-rewards", label: "Bonus Rewards", href: "#bonus-rewards" },
      {
        id: "programme-info",
        label: "Programme Info",
        href: "#programme-info",
      },
      {
        id: "diabetes-facts",
        label: "Diabetes Facts",
        href: "#diabetes-facts",
      },
    ];

    return (
      <div className="header">
        <div className="left">
          <div className="logo">
            <img src={sunlifeLogo} alt="sunlife" />
            <img src={bookdocLogo} alt="bookdoc" />
          </div>
        </div>
        {currentPath === "/" && (
          <>
            <button
              className="menu-toggle"
              onClick={() => this.setState({ menuOpen: !menuOpen })}
              aria-label="Toggle menu"
            >
              <span />
              <span />
              <span />
            </button>
            <nav className={menuOpen ? "mobile-menu show" : "mobile-menu"}>
              <ul className="menu text-uppercase">
                {navLinks.map(({ id, label, href }) => (
                  <li key={id}>
                    <a
                      href={href}
                      className={activeItem === id ? "active" : ""}
                      onClick={() =>
                        this.setState({ activeItem: id, menuOpen: false })
                      }
                    >
                      {label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          </>
        )}
      </div>
    );
  }
}
